import { trackEvent } from '../dtmHelpers'

export default function setPageName({
  page,
  guid,
  episodeGuid,
}) {
  if (typeof window === 'undefined') return
  trackEvent('directPageView', {
    pagename: getPageName({ page, guid, episodeGuid }),
    site: 'player',
  })
}

export function getPageName({
  page,
  guid,
  episodeGuid,
}) {
  if (page === 'home') return 'home'
  return [
    'player',
    page,
    guid,
    episodeGuid,
  ].filter(item => Boolean(item)).join(':')
}
